import { Tab, Tabs } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

export interface TabItem {
  id: string;
  /**
   * `ReactNode` y no `string` para que un tab pueda avisar que algo pasa
   * adentro (por ejemplo el badge de sync fallado en datasets, MXH-5792).
   */
  label: React.ReactNode;
}

export type Props = {
  tabs: TabItem[];
  onClick: (id: TabItem["id"]) => void;
  showTab: TabItem["id"];
  "data-testid"?: string;
};

export default function SectionTabs(props: Props) {
  const { tabs, onClick, showTab } = props;
  const prefix = props["data-testid"] ?? "section-tabs__tab";
  return (
    <StyledTabs
      value={showTab}
      onChange={(_, newValue) => onClick(newValue)}
      indicatorColor="primary"
    >
      {tabs.map((tab, i) => {
        return (
          <Tab
            data-testid={`${prefix}-${tab.id}`}
            label={tab.label}
            key={tab.id}
            value={tab.id}
          />
        );
      })}
    </StyledTabs>
  );
}

const StyledTabs = withStyles({
  root: {
    borderBottom: "1px solid #d6dbe0",
  },
})(Tabs);
